import PropTypes from "prop-types";
import React, { createRef, Fragment, PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { PopoverBody } from "reactstrap";

import FormListButtonWrapper from "../../components/form/FormListButtonWrapper";
import FormSearchField from "../../components/form/FormSearchField";
import ListView from "../../components/listView/ListView";
import NavigationToolbar from "../../components/navigationToolbar";
import { popoverOrPortal } from "../../components/portal/popoverOrPortal";
import keyConstants from "../../constants/keyConstants";
import preprocessorQuery from "../../utils/preprocessorQuery";
import uniqueId from "../../utils/uniqueId";

class AddFilterDropdown extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      popoverOpen: false,
      searchText: "",
      highlightedFilterGroupIndex: -1
    };
    this.togglePopover = this.togglePopover.bind(this);
    this.selectFilterGroup = this.selectFilterGroup.bind(this);
    this.searchChanged = this.searchChanged.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onDownArrow = this.onDownArrow.bind(this);

    this.selectFilterGroup = this.selectFilterGroup.bind(this);
    this.filterOptionRenderer = this.filterOptionRenderer.bind(this);

    this._listViewDom = null;
    this._searchRef = createRef();

    this._popoverId = `addFilter-${uniqueId()}`;
  }

  togglePopover() {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
      searchText: ""
    });
  }

  selectFilterGroup(filter) {
    this.setState(
      {
        popoverOpen: false,
        searchText: ""
      },
      () => {
        this.props.onGroupToggled(filter, true);
      }
    );
  }

  searchChanged(searchText) {
    this.setState({ searchText, highlightedFilterGroupIndex: -1 });
  }

  clearSearch() {
    this.setState({ searchText: "" });
  }

  renderMenuSearch() {
    return (
      <FormSearchField
        //#!if iOS !== true
        autoFocus={true}
        //#!endif
        ref={this._searchRef}
        placeholder="Filter"
        value={this.state.searchText}
        onChange={this.searchChanged}
        onDownArrow={this.onDownArrow}
        continuouslyUpdates={true}
        showSearchIcon={true}
        showClearIcon={true}
      />
    );
  }

  onDownArrow() {
    this._listViewDom ? this._listViewDom.focus() : null;
    this.setState({ highlightIndex: 0 });
  }

  onKeyDown(e) {
    if (e.key === keyConstants.Down) {
      e.preventDefault();
      this._listViewDom ? this._listViewDom.focus() : null;
      this.setState({ highlightedFilterGroupIndex: 0 });
    } else {
      this._searchRef && this._searchRef.current ? this._searchRef.current.focus() : null;
    }
  }

  getFilterOptions() {
    const lowerSearch = this.state.searchText.toLowerCase();
    const filteredOptions = lowerSearch
      ? this.props.collapsedGroups.filter(opt => opt.label.toLowerCase().indexOf(lowerSearch) >= 0)
      : this.props.collapsedGroups;

    return filteredOptions;
  }

  filterOptionRenderer(filter, isSelected, ref) {
    return (
      <div
        ref={ref}
        className={`relationshipPopoverListItem${isSelected ? " highlight" : ""}`}
        key={filter.value}
        onClick={() => this.selectFilterGroup(filter.value)}
      >
        <span>{filter.label}</span>
      </div>
    );
  }

  getListView() {
    const filterOptions = this.getFilterOptions();

    const selectedIndex = this.state.highlightedFilterGroupIndex;
    const onItemClick = newIndex =>
      this.selectFilterGroup(filterOptions.find((item, index) => index === newIndex).value);

    return (
      <ListView
        className="relationshipPopoverList"
        items={filterOptions}
        selectedItemIndex={selectedIndex}
        onItemSelect={onItemClick}
        itemRenderer={this.filterOptionRenderer}
        getDom={listViewDom => (this._listViewDom = listViewDom)}
      />
    );
  }

  renderPopover() {
    const isMobile = preprocessorQuery.isMobile();

    let placement = "bottom-start";
    let hideArrow = false;
    let alwaysPortal = false;
    //#!if tablet === true
// placement = "right-start";
    //#!endif

    let popoverOptions = {
      className: `relationshipPopover`,
      placement,
      hideArrow,
      isOpen: this.state.popoverOpen,
      target: this._popoverId,
      toggle: this.togglePopover
    };

    const child = (
      <Fragment>
        {isMobile ? (
          <NavigationToolbar
            title={this.props.title}
            showBack={true}
            showBackArrow={true}
            onBackClick={this.togglePopover}
            backText={this.props.backText ? this.props.backText : "Back"}
            flexLeft={1}
            flexCenter={3}
            flexRight={1}
          />
        ) : null}
        <PopoverBody onClick={e => e.stopPropagation()}>
          <div id="addFilterPopover" className="addFilterPopover" onKeyDown={this.onKeyDown}>
            {this.renderMenuSearch()}
            {this.getListView()}
          </div>
        </PopoverBody>
      </Fragment>
    );

    return popoverOrPortal(child, popoverOptions, alwaysPortal);
  }

  render() {
    return (
      <Fragment>
        <FormListButtonWrapper id="addFilter" onClick={this.togglePopover}>
          <div id={this._popoverId} className="tertiaryBtn addFilter">
            <svg className={"icon"}>
              <use xlinkHref="#listAdd" />
            </svg>
            {this.props.addButtonLabel ? this.props.addButtonLabel : "More Filters"}
          </div>
        </FormListButtonWrapper>
        {this.state.popoverOpen ? this.renderPopover() : null}
      </Fragment>
    );
  }
}

AddFilterDropdown.propTypes = {
  collapsedGroups: ImmutablePropTypes.list.isRequired,
  onGroupToggled: PropTypes.func.isRequired,
  title: PropTypes.string,
  backText: PropTypes.string,
  filterId: PropTypes.string,
  addButtonLabel: PropTypes.string,

  //#!if iOS === true || harvard === true
  // From withScreenContext
  screenContext: PropTypes.object
  //#!endif
};

export default AddFilterDropdown;
